import { useQuery } from "react-query";
import { QuestionnaireResponse } from "../../../../models/Questionnaire";
import { getApiInstance } from "../../../api";
import queryWrapper from "../../queryWrapper";
import ApiClient from "../../../apiClient";

export const questionnaireKey = "questionnaire-key";

export async function questionnaire(): Promise<QuestionnaireResponse[]> {
  const res = await ApiClient.get(`/Questionnaire`);
  return res.data;
}

export default function useFetchQuestionnaire() {
  return useQuery([questionnaireKey], queryWrapper(questionnaire));
}
